<!-- Content -->
@if ((nodeSharedFacade.currentSelectedChapterPage$ | async); as page) {
  <div class="mdsf-quiz-start-container">
    @if ((trainingSharedFacade.selectedNodesSet$ | async); as selectedTrainings) {
      <div id="quiz-content">

        <div class="scrollable editor-input">
          <medsurf-text-format [text]="page.body"></medsurf-text-format>
        </div>
        <br/>
        <br/>

        <div id="form-container">
          <div class="mdsf-quiz-list">
            @if ((trainingSharedFacade.quizStartData$ | async); as quizStartData) {

              <label class="mdsf-quiz-list-header">
                @if ({checked: isChecked(quizStartData, selectedTrainings), indeterminate: isIndeterminate(quizStartData, selectedTrainings)}; as data) {
                  <input type="checkbox"
                    id="check-all-quiz"
                    value="all"
                    [checked]="data.checked"
                    [indeterminate]="data.indeterminate && !data.checked"
                    (change)="trainingSharedFacade.requestToggleTrainingSelection(quizStartData.nodeIds, $event)">
                }
                <span translate="select_all" for="check-all-quiz"></span>
              </label>

              @for (chapter of quizStartData.items | sortBy_shared:'asc':'position'; track chapter.id) {
                <div class="mdsf-quiz-list-group">
                  <label class="mdsf-quiz-list-group-header">
                    @if ({checked: isChecked(chapter, selectedTrainings), indeterminate: isIndeterminate(chapter, selectedTrainings)}; as data) {
                      <input type="checkbox"
                        [checked]="data.checked"
                        [indeterminate]="data.indeterminate && !data.checked"
                        (change)="trainingSharedFacade.requestToggleTrainingSelection(chapter.nodeIds, $event)">
                    }
                    <h1 class="mr-4">{{ chapter.page.title }}</h1>
                    <span class="ml-auto flex-shrink-0">{{ chapter.nodeIds.length }} {{ chapter.nodeIds.length === 1 ? ("slide" | translate) : ("slides" | translate) }}</span>
                    <button class="mdsf-quiz-list-group-expand" (click)="toggleExpanded(chapter, $event)">
                      <i class="fa" [class.fa-chevron-down]="!chapter.expanded" [class.fa-chevron-up]="chapter.expanded" aria-hidden="true"></i>
                    </button>
                  </label>

                  @for (block of chapter.children | sortBy_shared:'asc':'position'; track block.id) {
                    <label class="mdsf-quiz-list-group-item" [class.hidden]="!chapter.expanded">
                      @if ({checked: isChecked(block, selectedTrainings), indeterminate: isIndeterminate(block, selectedTrainings)}; as data) {
                        <input class="checkbox"
                          type="checkbox"
                          [checked]="data.checked"
                          [indeterminate]="data.indeterminate && !data.checked"
                          (change)="trainingSharedFacade.requestToggleTrainingSelection(block.nodeIds, $event)">
                      }
                      <span class="mr-auto text-truncate">{{ block.page.title }}</span>
                      <span class="ml-4 flex-shrink-0">
                        {{ block.nodeIds.length }} {{ block.nodeIds.length === 1 ? ("slide" | translate) : ("slides" | translate) }}
                      </span>
                    </label>
                  }
                </div>
              }
            } @else {
              <div class="d-flex justify-content-center m-2">
                <div class="spinner-border"></div>
              </div>
            }
          </div>
        </div>
        <br/>
        <div class="btn-group d-flex justify-content-end">
          <button class="mdsf-btn mdsf-btn-primary"
            [disabled]="selectedTrainings.size < 1"
            (click)="trainingSharedFacade.requestStartTraining()"
          translate="start_quiz"></button>
        </div>
      </div>
    } @else {
      <div class="d-flex justify-content-center m-2">
        <div class="spinner-border"></div>
      </div>
    }
  </div>
} @else {
  <div class="d-flex justify-content-center m-2">
    <div class="spinner-border"></div>
  </div>
}
